module.exports = __webpack_public_path__ + "static/media/logout-grey.e62ed06f.svg";